"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFlashOrder = void 0;
var create_flash_order_1 = require("./create-flash-order");
Object.defineProperty(exports, "createFlashOrder", { enumerable: true, get: function () { return create_flash_order_1.createFlashOrder; } });
